<template>
  <div id="Footer">
    <!-- <div>Copyright {{host}} All rights reserved 版权所有</div> -->
  </div>
</template>
<script>
let host = window.location.host;
export default {
  name: "Footer",
  data() {
    return {
      host
    };
  }
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/components/Footer/index.vue